<script setup lang="ts">
import { ref } from 'vue';
import apiClient from '@src/api/api-client.ts';
import { FormPartEmitsType, FormPartProps, useFormPartComposable } from '@src/form/composables/form-part-composable.ts';
import Select from '@components/form/select.vue';
import { Bin } from '@src/warehouse/interfaces/bin.ts';

const { label = 'Lager auswählen' } = defineProps<FormPartProps & { label?: string|false }>();

const modelValue = defineModel<Bin|null>({ default: null });

const { submit, exposes: formPartExposes } = useFormPartComposable(modelValue);

defineExpose({ ...formPartExposes });

const oneBinWarehouses = ref((await apiClient.get('/be/warehouse/one-bin-warehouses')).data);

defineEmits<FormPartEmitsType>();
</script>

<template>
    <Select
        v-model="modelValue"
        :options="oneBinWarehouses"
        label-property="binCode"
        :label="label"
        large
        required
        @submit="submit"
    />
</template>
